import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ReportContext, ReportDefinition } from '../../report.models';
import { RouteAnalysisTableComponent } from '../route-function-report/route-analysis-report/route-analysis-table.component';
import { RouteActionEvent } from '../route-function-report/route-analysis-report/route-analysis-report.models';
import { DeviceEventRow } from './device-events-report.models';
import { DeviceEventsReportApiService } from './device-events-report-api.service';
import { DEVICE_EVENT_ACTIONS, DEVICE_EVENT_COLUMNS, DEVICE_EVENT_EXPORT_COLUMNS, DEVICE_EVENT_STATUSES, DEVICE_INPUT_COLUMNS, DEVICE_INPUT_EXPORT_COLUMNS, JOURNAL_COLUMNS, JOURNAL_EXPORT_COLUMNS } from './device-events-report.utils';

@Component({ selector: 'app-device-events-report', templateUrl: './device-events-report.component.html' })
export class DeviceEventsReportComponent implements OnChanges, OnDestroy {
  @Input() context!: ReportContext;
  @Input() definition!: ReportDefinition;
  @ViewChild(RouteAnalysisTableComponent) table?: RouteAnalysisTableComponent;
  rows: DeviceEventRow[] = [];
  visibleRows: DeviceEventRow[] = [];
  status = '';
  filtersOpen = false;
  loading = false;
  hasError = false;
  readonly statuses = DEVICE_EVENT_STATUSES;
  readonly actions = DEVICE_EVENT_ACTIONS;
  private version = 0;
  constructor(private readonly api: DeviceEventsReportApiService, private readonly guard: GurdServiceService,
    private readonly notification: NotificationService, private readonly other: OtherService,
    private readonly router: Router, private readonly location: Location) {}
  get isEvents(): boolean { return this.context.type === '7'; }
  get isInputs(): boolean { return this.context.type === '8'; }
  get columns() { return this.isInputs ? DEVICE_INPUT_COLUMNS : this.isEvents ? DEVICE_EVENT_COLUMNS : JOURNAL_COLUMNS; }
  get exportColumns() { return this.isInputs ? DEVICE_INPUT_EXPORT_COLUMNS : this.isEvents ? DEVICE_EVENT_EXPORT_COLUMNS : JOURNAL_EXPORT_COLUMNS; }
  get searchColumns() { return this.isInputs ? [...DEVICE_INPUT_COLUMNS, { field: 'strIOName', title: 'نام ورودی' }] : this.columns; }
  get subtitle(): string { return `از تاریخ ${this.context.startDate} الی ${this.context.endDate}`; }
  get tableKey(): string { return `device-${this.context.id}-${this.context.type}`; }
  ngOnChanges(): void {
    if (!this.context || !this.definition) return;
    ++this.version;
    this.loading = false;
    this.rows = this.visibleRows = [];
    this.status = '';
    this.filtersOpen = false;
    this.table?.reset();
    void this.loadReport();
  }
  ngOnDestroy(): void { ++this.version; }
  async loadReport(): Promise<void> {
    if (this.loading) return;
    const version = ++this.version;
    this.loading = true;
    this.hasError = false;
    try {
      const result = await this.api.load(this.definition, this.context, this.decrypt('ID'), this.decrypt('Session'), this.isEvents ? this.decrypt('deviceEvents') : '');
      if (version !== this.version) return;
      if (!Array.isArray(result)) {
        this.notification.showError('لطفا وارد سیستم شوید');
        this.other.removeLocalStorage();
        void this.router.navigate(['login'], this.definition.loginReport ? { queryParams: { report: this.definition.loginReport } } : undefined);
        return;
      }
      this.rows = result;
      if (this.isInputs) this.api.cacheInputs(result);
      this.refreshRows();
    } catch {
      if (version !== this.version) return;
      this.rows = this.visibleRows = [];
      this.hasError = true;
    } finally { if (version === this.version) this.loading = false; }
  }
  changeStatus(): void { if (!this.loading) this.refreshRows(); }
  clearFilters(): void {
    if (this.loading) return;
    this.status = '';
    this.table?.reset();
    this.refreshRows();
  }
  toggleFilters(): void { if (!this.loading) this.filtersOpen = !this.filtersOpen; }
  onRowAction(event: RouteActionEvent): void {
    if (this.loading || event.action !== 'map') return;
    const row = event.row;
    const values = { fLat: row.fLat, fLon: row.fLon, commentJournal: this.isInputs ? row['strIOName'] : this.isEvents ? row['strDeviceEventsType_strComment'] : row['strComment'], timeJournal: row['strTime'], dateJournal: row.strDate };
    for (const [key, value] of Object.entries(values)) localStorage.setItem(key, this.guard.encrypt(value == null ? '' : String(value)));
    void this.router.navigate(['stopMap/1']);
  }
  goBack(): void { this.location.back(); }
  openAllOnMap(): void {
    if (this.loading || this.hasError || !this.rows.length) return;
    void this.router.navigate(['/stopMap/', this.context.id + (this.isInputs ? '_' : this.isEvents ? '-' : '*')]);
  }
  private decrypt(key: string): string { return this.guard.decrypt(localStorage.getItem(key)!); }
  private refreshRows(): void {
    this.visibleRows = this.status ? this.rows.filter(row => row.strDeviceStatus_strComment === this.status) : [...this.rows];
  }
}
